import { debounce } from 'lodash'
import { observer } from 'mobx-react-lite'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { AppSearchBar } from 'src/component/common/analog/molecule/AppSearchBar'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { Box } from '@mui/material'
import { GoBackButtonWithArrow } from 'src/component/common/original/molecule/GoBackButtonWithArrow'
import { useState } from 'react'
import { Word } from 'src/feature/localization/component/atom/Word'

export type CategorySearchProps = {
  categoryKey: string
  setSearchTerm: (term: string) => void
}

export const CourseSearch = observer(({ categoryKey, setSearchTerm }: CategorySearchProps) => {
  const { translation } = useLocalizationStore()
  
  const { categories } = translation.pages.eLearning
  type ObjectKey = keyof typeof categories
  const texts = categories[categoryKey as ObjectKey]
  const [isFocused, setIsFocused] = useState(false)

  const handleSearch = debounce(async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length > 1) {
      setSearchTerm(event.target.value)
    } else if (event.target.value.length === 0) {
      setSearchTerm('')
    }
  }, 750)

  return (
    <Box sx={styles.root}>
      <AppBox alignItems='center' gap={5}>
        <GoBackButtonWithArrow
          sx={{ margin: '0 !important' }}
          textValue={`${translation.pages.eLearning.courses()} >`}
        />
        <Word sx={{ color: 'secondary.main', fontWeight: 'bold', fontSize: 15 }}>{texts.title()}</Word>
      </AppBox>
      <AppBox sx={{
        ...styles.searchbarContainer,
        ...(isFocused ? { width: '14rem' } : { width: '7rem' }),
      }}>
        <AppSearchBar
          onChange={handleSearch}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
      </AppBox>
    </Box>
  )
})

const styles = {
  root: {
    display: 'flex',
    flexDirection: { lg: 'row', md: 'row', xs: 'column' },
    justifyContent: { lg: 'space-between', md: 'space-between', xs: 'center' },
    alignItems: 'center',
    width: '100%',
    gap: 30,
  },
  searchbarContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    width: '7rem',
    transition: 'width 0.3s ease-in-out',
  },
}
